import RichText from "../../../../CmsComponents/RichText/RichText";
import { BNBox, BNStack } from "@bn-monorepo/js-packages";

interface Price {
  title: string;
  price: string;
}

export interface IPrice {
  title?: string;
  description?: string;
  terms?: string;
  list: Price[];
  type: "compact" | "big";
}

const Prices: ReactFCWithNoJs<IPrice> = (props) => {
  const { title, list, description, type, terms } = props;

  switch (type) {
    case "compact":
      return (
        <>
          <BNBox component={"table"} sx={{ width: "100%", my: "2em" }}>
            {title && (
              <thead>
                <tr>
                  <th col-span="2">
                    <BNBox component={"h3"} sx={{ m: "0 0 0.25em 0" }}>
                      {title}
                    </BNBox>
                  </th>
                </tr>
              </thead>
            )}
            <tbody>
              {list.map((insurance, index) => (
                <BNBox
                  component={"tr"}
                  sx={{
                    backgroundColor: "background.paper",
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    borderRadius: "0.25em",
                    p: "0.5em",
                    m: "0.2em 0",
                  }}
                  key={`InsurancesAvaliable-${index}`}
                >
                  <BNBox component={"th"} {...{ scope: "row" }} sx={{ fontSize: "0.8em", pr: "0.5em" }}>
                    {insurance.title}
                  </BNBox>
                  <BNBox component={"td"} sx={{ fontSize: "0.8em" }}>
                    {insurance.price}
                  </BNBox>
                </BNBox>
              ))}
            </tbody>
          </BNBox>
          {terms && <RichText sx={{ fontSize: { xs: "1.4rem", sm: "1.6rem" } }} html={terms as any} />}
        </>
      );
    case "big":
      return (
        <>
          <BNStack sx={{ justifyContent: "center", margin: { sm: "0 auto" } }}>
            {list && (
              <>
                <BNBox component={"table"} sx={{ width: "100%" }}>
                  {title && (
                    <thead>
                      <tr>
                        <th col-span="2">
                          <BNBox
                            component={"h3"}
                            sx={{
                              fontSize: { xs: "1.6rem", sm: "1.8rem" },
                              textAlign: "center",
                              margin: { xs: "1.5em 0 0.5em 0", sm: "2em 0 0 0" },
                            }}
                          >
                            {title}
                          </BNBox>
                        </th>
                      </tr>
                    </thead>
                  )}
                  <BNStack component={"tbody"} sx={{ gap: "0.1rem" }}>
                    {list.map((row, index) => (
                      <BNStack
                        component={"tr"}
                        direction="row"
                        key={`price-row-${index}`}
                        sx={{
                          justifyContent: "space-between",
                          backgroundColor: "background.paper",
                          p: 2,

                          "&:first-of-type": {
                            borderTopLeftRadius: "0.8rem",
                            borderTopRightRadius: "0.8rem",
                          },

                          "&:last-of-type": {
                            borderBottomLeftRadius: "0.8rem",
                            borderBottomRightRadius: "0.8rem",
                          },
                        }}
                      >
                        <BNBox
                          component={"th"}
                          {...{ scope: "row" }}
                          sx={{
                            fontSize: { xs: "1.4rem", sm: "1.6rem" },
                            pr: "0.5em",
                            wordBreak: "break-word",
                            textAlign: "left",
                          }}
                        >
                          {row.title}
                        </BNBox>
                        <BNBox
                          component={"td"}
                          sx={{
                            fontSize: { xs: "1.4rem", sm: "1.6rem" },
                            textAlign: "right",
                            minWidth: "25%",
                          }}
                        >
                          {row.price}
                        </BNBox>
                      </BNStack>
                    ))}
                  </BNStack>
                </BNBox>
                {description && (
                  <BNBox component={"p"} sx={{ fontSize: { xs: "1.4rem", sm: "1.6rem" }, my: "1em" }}>
                    {description}
                  </BNBox>
                )}
              </>
            )}
            {terms && <RichText sx={{ fontSize: { xs: "1.4rem", sm: "1.6rem" } }} html={terms} />}
          </BNStack>
        </>
      );
  }
};
Prices.noJsRequired = true;
export default Prices;
